import React, { useState } from 'react'
import { QuickFilterScope } from '../../../enums/quick-filters';
import { IFilterOption } from './types';
import CustomDialog from '../custom-dialog/custom-dialog';
import { Box, CircularProgress, DialogContent, DialogTitle, FormControl, Typography } from '@mui/material';
import { Button, TextField } from '@mui/material';
import { DialogActions } from '@mui/material';
import { IQuickFilter } from '../../../interfaces/common/quick-filters';
import { filterOptionsToQuickFilter } from '../../../utils/quick-filters';
import {FilterOptionsChips} from './filter-chips';
import { useSnackBar } from '../../../contexts/snackbar';
import { useQuickFiltersContext } from '../../../contexts/quick-filters-context';
import TextFieldWithArabicKeyboard from '../text-field-with-arabic-keyboard';

interface SaveAsQuickFilterDialogProps {
    open: boolean;
    onClose: () => void;
    filterOptions: IFilterOption[];
    quickFiltersScope: QuickFilterScope;
    onSuccess: (filter: IQuickFilter) => void;
}

function SaveAsQuickFilterDialog({
    open,
    onClose,
    filterOptions,
    quickFiltersScope,
    onSuccess
}: SaveAsQuickFilterDialogProps)  {
  const [quickFilterInput, setQuickFilterInput] = useState<IQuickFilter>({
    name: '',
    description: '',
    filters: filterOptionsToQuickFilter(filterOptions),
    scope: quickFiltersScope,
  });

  const {showMessage} = useSnackBar();

  const {quickFilters, isLoading, createQuickFilter} = useQuickFiltersContext();

  const handleSave = async () => {
    const filter = await createQuickFilter(quickFilterInput);
    if (filter) {
      onSuccess(filter);
      showMessage('Quick filter saved successfully');
      onClose();
    }
  }

  const nameAlreadyExists = quickFilters.some((quickFilter) => quickFilter.name === quickFilterInput.name && quickFiltersScope == quickFilter.scope);

  const disabledSubmit = isLoading || nameAlreadyExists || quickFilterInput.name.length === 0

  return <CustomDialog open={open} onClose={onClose} maxWidth={'md'} fullWidth> 
            <DialogTitle>
                <Typography variant="h4" align="center">
                    Save as Quick Filter
                </Typography>
            </DialogTitle>
            <DialogContent>
            <Box
                sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, marginBottom: 2 }}
            >
                <FilterOptionsChips filterOptions={filterOptions} />
            </Box>
            {
                isLoading ? <CircularProgress /> :  <>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <TextField 
                            label="Name" 
                            placeholder="For example: Important Orders"
                            value={quickFilterInput.name} 
                            onChange={(e) => setQuickFilterInput({ ...quickFilterInput, name: e.target.value })} 
                            fullWidth 
                            error={nameAlreadyExists}
                            helperText={nameAlreadyExists ? "Name already in use" : ""}
                            required
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <TextFieldWithArabicKeyboard 
                            label="Description" 
                            placeholder="For example: Delivered Orders that are not yet paid to me."
                            value={quickFilterInput.description} 
                            onChange={(v) => setQuickFilterInput({ ...quickFilterInput, description: v })} 
                            fullWidth 
                            multiline
                            minRows={4}
                        />
                    </FormControl>
                </>
            }
               
                
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={onClose}>Cancel</Button>
                <Button disabled={disabledSubmit} onClick={handleSave}>Save</Button>
            </DialogActions>
  </CustomDialog>
}

export default SaveAsQuickFilterDialog